import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5030/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;

// Helper functions
export const getData = async (url, params = {}) => {
  const response = await api.get(url, { params });
  return response.data;
};

export const postData = async (url, data, isFormData = false) => {
  const config = isFormData ? { headers: { 'Content-Type': undefined } } : {};
  const response = await api.post(url, data, config);
  return response.data;
};

export const putData = async (url, data) => {
  const response = await api.put(url, data);
  return response.data;
};

export const patchData = async (url, data) => {
  const response = await api.patch(url, data);
  return response.data;
};

export const deleteData = async (url) => {
  const response = await api.delete(url);
  return response.data;
};
